import { render, staticRenderFns } from "./RegistrosAnteriores.vue?vue&type=template&id=2a216c94&"
import script from "./RegistrosAnteriores.vue?vue&type=script&lang=js&"
export * from "./RegistrosAnteriores.vue?vue&type=script&lang=js&"
import style0 from "./RegistrosAnteriores.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports